import { useEffect, useState } from "react";
import { Dispatch, SetStateAction } from "react";
import { Box, Flex } from "@storyofams/react-ui";
import { findIndex, filter, find } from "lodash";
import styled from "styled-components";
import { Text } from "../../../components";
import { SelectedOptionInput } from "../../../lib/shopify/sdk";

interface Props {
  setSelectedOptions: Dispatch<SetStateAction<SelectedOptionInput[]>>;
  selectedOptions?: SelectedOptionInput[];
  available?: any;
  secondAvailable?: any;
  product;
}

const Label = styled(Flex).attrs({
  as: "label",
  flex: 1,
  justifyContent: "center",
  px: "2",
  py: "auto",
  height: 52,
  bg: "white",
  border: "1px",
  borderRadius: "md",
  fontWeight: "bold",
  transition: "all .18s ease-in-out",
  cursor: "pointer",
})`
  text-transform: uppercase;
`;

const Radio = styled(Flex).attrs({
  as: "input",
  type: "radio",
})`
  appearance: none;

  + label {
    border-color: ${(p) => p.theme.colors.grey200};
  }

  &:checked {
    + label {
      border-color: ${(p) => p.theme.colors.grey800};
    }
  }

  &:disabled + label {
    opacity: 0.4;
  }

  &:hover:not(:checked) {
    + label {
      box-shadow: inset 0px 0px 0px 1px ${(p) => p.theme.colors.grey200};
    }
  }
`;

export const OptionSelector = ({
  setSelectedOptions,
  selectedOptions = [],
  product,
}: Props) => {
  const [availableOptions, setAvailableOptions] = useState([]);
  const [availableSecondOptions, setAvailableSecondOptions] = useState([]);
  useEffect(() => {
    const available = [];

    product?.variants?.edges?.map(({ node }) => {
      if (
        node?.selectedOptions[0]?.value === selectedOptions[0]?.value &&
        node?.availableForSale
      ) {
        available.push(node);
      }
    });

    setAvailableSecondOptions(available);
  }, [selectedOptions]);

  useEffect(() => {
    const inStock = filter(product?.variants?.edges, function (item) {
      return item.node.availableForSale;
    });

    setAvailableOptions(inStock);
  }, [product]);
  const filterOptions = () => {
    return product.options.map((option) => {
      return {
        ...option,
        values: option.values.filter((values) => {
          return product.variants?.edges.find(({ node }) => {
            return node.title.includes("+")
              ? node.title === values
              : (node.title as string).includes(values);
          });
        }),
      };
    });
  };
  const checkIsAvailable = (value, name) => {
    if (name === "Dop" && selectedOptions.length) {
      const variants = product?.variants?.edges.filter(
        ({ node }) => node.selectedOptions[0].value === selectedOptions[0].value
      );
      const avaiable = variants.find(
        ({ node }) => node.selectedOptions[1].value === value
      );
      if (!avaiable) return false;
      return true;
    }
    return true;
  };
  return (
    <>
      {filterOptions().map((option, i) => {
        const selectedOption = selectedOptions?.[i];
        const { name, values } = option;
        const isEmpty = values.includes("-");
        return (
          <Box width="100%" key={name}>
            {!isEmpty && (
              <Text mb={1} fontSize={1.75} color="grey600">
                {option.name}
              </Text>
            )}

            <Box
              width="100%"
              display="grid"
              gridTemplateColumns={[
                "repeat(2, 1fr)",
                values?.length >= 3
                  ? "repeat(3, 1fr)"
                  : `repeat(${values?.length}, 1fr)`,
              ]}
              gridColumnGap={[1.5]}
              gridRowGap={[1.5]}
            >
              {!isEmpty &&
                values.map((value, index) => {
                  let available = false;

                  if (i === 0) {
                    available = find(availableOptions, function (item) {
                      return item.node.selectedOptions[0]?.value === value;
                    });
                  }

                  if (i === 1) {
                    available = find(availableSecondOptions, function (item) {
                      return item.selectedOptions[1]?.value === value;
                    });
                  }
                  return (
                    <Box flex={1} key={value}>
                      <Radio
                        disabled={!checkIsAvailable(value, name)}
                        id={value}
                        checked={selectedOption?.value === value}
                        onChange={() =>
                          setSelectedOptions((options) => {
                            return options.map((item) => {
                              if (item.name === name) return { name, value };
                              return item;
                            });
                          })
                        }
                      />

                      <Label
                        htmlFor={value}
                        flexDirection="column"
                        alignItems={"center"}
                        textAlign="center"
                      >
                        {value?.split("(")[0]}

                        {!!value?.split("(")[1] && (
                          <Text textAlign={"start"} fontSize={"12px"}>
                            {"(" + value?.split("(")[1]}
                          </Text>
                        )}
                      </Label>
                    </Box>
                  );
                })}
            </Box>
          </Box>
        );
      })}
    </>
  );
};
